import type { PropostaItem, PropostaItemTipo, PropostaStatus } from '@/types'
import type { BadgeVariant } from '@/components/ui/Badge'

export interface PlanOption {
  id: string
  nome: string
  descricao?: string
  category?: string
  valorMensal: number
  valorSetup?: number
  // Fields from API config (Configuração → Planos)
  services?: any[]         // Extracted & normalized from config.deliverables or config.services
  duration?: number        // Fidelidade / contrato em meses
  pricing?: {
    total?: number
    entry?: number
    installments?: number
    installmentValue?: number
    recorrente?: boolean
    duracao?: number
  }
  showBonus?: boolean
  bonus?: string
  /** Payload bruto da API — usado para montar item com escopo atualizado do catálogo */
  raw?: Record<string, unknown>
}

export interface ComboData {
  id: string
  nome: string
  desconto: number
  itemIds: string[]
}

export interface ComboValue extends ComboData {
  items: PropostaItem[]
  subtotal: number
  descontoValor: number
  total: number
}

export const proposalStatusConfig: Record<
  PropostaStatus,
  { label: string; variant: BadgeVariant }
> = {
  rascunho: { label: 'Rascunho', variant: 'warning' },
  enviada: { label: 'Enviada', variant: 'info' },
  aceita: { label: 'Aceita', variant: 'success' },
  rejeitada: { label: 'Rejeitada', variant: 'danger' },
  recusada: { label: 'Recusada', variant: 'danger' },
  expirada: { label: 'Expirada', variant: 'muted' },
}

import { Wrench, Layers, Package } from 'lucide-react'

export const itemTipoConfig: Record<PropostaItemTipo, { label: string; icon: React.ElementType }> = {
  servico: { label: 'Serviço', icon: Wrench },
  plano: { label: 'Plano', icon: Layers },
  avulso: { label: 'Avulso', icon: Package },
}

/** Normaliza tipos legados/alternativos vindos da API para o enum da proposta. */
export function resolvePropostaItemTipo(tipo?: string | null): PropostaItemTipo {
  const raw = String(tipo || '').toLowerCase()
  if (raw === 'servico' || raw === 'setup') return 'servico'
  if (raw === 'plano' || raw === 'recorrente' || raw === 'mensal') return 'plano'
  if (raw === 'avulso' || raw === 'generico') return 'avulso'
  return 'plano'
}

export function getItemTipoConfig(tipo?: string | null) {
  return itemTipoConfig[resolvePropostaItemTipo(tipo)]
}

export function generateId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
}
